/*=========================================================================================
  File Name: moduleRolesState.js
  Description: Roles Module State
==========================================================================================*/

export default {
	roles: [],
	showRolesCategorySidebar: false,
	total: 0,
	limitPerPage: 10
};
